import { render } from "./ObligationView.vue?vue&type=template&id=5c396dad"
import script from "./ObligationView.vue?vue&type=script&lang=js"
export * from "./ObligationView.vue?vue&type=script&lang=js"

import "./ObligationView.vue?vue&type=style&index=0&id=5c396dad&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/view/ObligationView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5c396dad"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5c396dad', __exports__)) {
    api.reload('5c396dad', __exports__)
  }
  
  module.hot.accept("./ObligationView.vue?vue&type=template&id=5c396dad", () => {
    api.rerender('5c396dad', render)
  })

}


export default __exports__